import { AxiosResponse} from "axios";
import Api from "../api";

export default (types : string,adId : string): Promise<AxiosResponse> => {
    const path = 'post-stats'
    return Api.getInstance().request.get(`${path}/${adId}/lead-users?types=${types}`, path)
}